/**
* Wrapper object that extends KOCalendar functionality and includes two
* calendar instances, the second always being one month ahead of the first
*
* @class KOMiniCalendar
* @requires KOCalendar
*/
var KOMiniCalendar = function () {
	var self = this;

	/**
	*  Observable variables for this mini calendar object
	*/
	self.cal			= new KOCalendar();			// Contains a KOCalendar
	self.cal2			= new KOCalendar();			// Contains a KOCalendar,
													// one month ahead of self.cal


	/**
	* This passes the buildMonth call through to the KOCalendar referred to in cal()
	* and then updates the second KOCalendar instance in cal2;
	*
	* @method buildMonth
	* @param {Date} [dRequestedDate] A date contained within the calendar month
	* @return {KOMiniCalendar} Returns the object as chainable, for best practice
	*/
	self.buildMonth = function ( dDate, bSkipTZCheck ) {
		self.cal.buildMonth( dDate, bSkipTZCheck );

		self.updateCal2();

		// Return self (KOMiniCalendar) to be chainable, for best practice
		return self;
	};


	/**
	* This passes the changeMonth call through to the KOCalendar referred to in cal()
	* and then updates the second KOCalendar instance in cal2;
	*
	* @method changeMonth
	* @param {Integer} iChangeAmount A signed integer indicating how many months to move
	* @return {KOMiniCalendar} Returns the object as chainable, for best practice
	*/
	self.changeMonth = function ( iChangeAmount ) {
		self.cal.changeMonth( iChangeAmount );

		self.updateCal2();

		// Return self (KOMiniCalendar) to be chainable, for best practice
		return self;
	};


	/**
	* This passes the changeWeek call through to the KOCalendar referred to in cal()
	* and then updates the second KOCalendar instance in cal2;
	*
	* @method changeWeek
	* @param {Integer} iChangeAmount A signed integer indicating how many weeks to move
	* @return {KOMiniCalendar} Returns the object as chainable, for best practice
	*/
	self.changeWeek = function ( iChangeAmount ) {
		self.cal.changeWeek( iChangeAmount );

		self.updateCal2();

		// Return self (KOMiniCalendar) to be chainable, for best practice
		return self;
	};


	/**
	* This passes the changeDate call through to the KOCalendar referred to in cal()
	* and then updates the second KOCalendar instance in cal2;
	*
	* @method changeDate
	* @param {Integer} iChangeAmount A signed integer indicating how many days to move
	* @return {KOMiniCalendar} Returns the object as chainable, for best practice
	*/
	self.changeDate = function ( iChangeAmount ) {
		self.cal.changeDate( iChangeAmount );

		self.updateCal2();

		// Return self (KOMiniCalendar) to be chainable, for best practice
		return self;
	};



	/**
	* This method allows for the KOCalendar instance to have persistence, vs
	* having to throw away the old calendar and create a new one. By passing a
	* signed integer to this method, the month can be changed forward or backward
	* any number of months
	*
	* @method setMonth
	* @param {Integer} iMonth The month to change the calendar to
	* @param {function} fCallback Function to be executed once the month has been set
	* @return {KOCalendar} Returns the object as chainable, for best practice
	*/
	self.setMonth = function ( iMonth ) {
		self.cal.setMonth( iMonth );

		self.updateCal2();

		// Return self (KOCalendar) to be chainable, for best practice
		return self;
	};


	/**
	* This method ensures that cal2 is always one month ahead of cal.
	*
	* @method updateCal2
	* @return {KOMiniCalendar} Returns the object as chainable, for best practice
	*/
	self.updateCal2 = function () {
		var dt2 = new moment( self.cal.today() );
		dt2.add( 1, 'months' );
		dt2.date( 1 );

		self.cal2.buildMonth( dt2 );

		// Return self (KOMiniCalendar) to be chainable, for best practice
		return self;
	};

	// Call the update method to ensure that we initialize our cal2 correctly
	self.updateCal2();

	return self;
};